import { BarChart } from "@mui/x-charts/BarChart";

const dataset = [
  { venue: "Hall", speed: 5 },
  { venue: "Hall", speed: 8 },
  { venue: "Hall", speed: 70 },

  { venue: "Unknown", speed: 1 },
  { venue: "Unknown", speed: 5 },

  { venue: "Tent", speed: 20 },

  { venue: "Chapel", speed: 1 },
  { venue: "Chapel", speed: 20 },

  { venue: "Funeral Parlour", speed: 5 },
  { venue: "Funeral Parlour", speed: 90 },

  { venue: "Church", speed: 2 },
  { venue: "Church", speed: 10 },

  { venue: "Other", speed: 1 },
  { venue: "Other", speed: 80 },

  { venue: "Crematorium", speed: 1 },
  { venue: "Private Residence", speed: 2 },
];

const SpeedByVenueType = () => {
  return (
    <BarChart
      dataset={dataset}
      xAxis={[
        {
          dataKey: "venue",
          scaleType: "band",
          label: "venue_type",
        },
      ]}
      series={[
        {
          dataKey: "speed",
          label: "internet_upload_speed",
        },
      ]}
      height={300}
    />
  );
};

export default SpeedByVenueType;
